import React from 'react';

// Tick de estado de entrega de un mensaje saliente, como en WhatsApp:
// ✓ gris (enviado), ✓✓ gris (entregado), ✓✓ azul (leído) y un icono rojo de
// error con el motivo de Meta en el texto accesible. Cualquier otro estado
// (null, `received` de los entrantes) no pinta nada.

const CHECK_IZQ = 'M1.5 8.5l3 3 6.5-7';
const CHECK_DER = 'M6.5 11.5l.5.5 6.5-7.5';

const ETIQUETAS = {
  sent: 'Enviado',
  delivered: 'Entregado',
  read: 'Leído',
};

const etiquetaDeFallo = (errorCode, errorMessage) => {
  const motivo = [errorCode, errorMessage].filter((p) => p != null && p !== '').join(' ');
  return `Error al enviar: ${motivo || 'motivo desconocido'}`;
};

function TickEntrega({ estado, errorCode = null, errorMessage = null }) {
  const clave = estado ? String(estado).toLowerCase() : null;

  if (clave === 'failed') {
    const etiqueta = etiquetaDeFallo(errorCode, errorMessage);
    return (
      <span className="tick-entrega tick-entrega--failed" role="img" aria-label={etiqueta} title={etiqueta}>
        <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">
          <circle cx="8" cy="8" r="7" fill="currentColor" stroke="#fff" strokeWidth="1" />
          <rect x="7.1" y="3.5" width="1.8" height="5.5" rx="0.9" fill="#fff" />
          <circle cx="8" cy="11.6" r="1.05" fill="#fff" />
        </svg>
      </span>
    );
  }

  const etiqueta = ETIQUETAS[clave];
  if (!etiqueta) return null;

  return (
    <span className={`tick-entrega tick-entrega--${clave}`} role="img" aria-label={etiqueta} title={etiqueta}>
      <svg viewBox="0 0 16 16" width="16" height="14" aria-hidden="true" focusable="false"
        fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d={CHECK_IZQ} />
        {clave !== 'sent' && <path d={CHECK_DER} />}
      </svg>
    </span>
  );
}

export default TickEntrega;
